import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import Quality from '../quality/Quality'
import QualityActions from '../quality/QualityActions'

// RN4/CA6 — the "Fabrication order acceptance" tab no longer lives inside Quality for any
// installation: the acceptance screen only exists as its own menu entry/route
// (/quality/productAcceptance, see MainQualityProductAcceptance). Quality keeps only its
// preexisting tabs (Quality Incidence, Actions), unaffected by this reorganization (RN5/CA9).
const MainQuality = () => {
  const { t_ } = useSmartTranslation()

  const componentsInfo = [
    {
      title: t_('QUALITY INCIDENCE'),
      component: <Quality />
    },
    {
      title: t_('ACTIONS'),
      component: <QualityActions />
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainQuality
